import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-3" }

import FormTextField from "@/components/Common/FormTextField.vue"; 
import FormRow from "@/components/Common/FormRow.vue";
import accountType from "@/types/account";
import { computed } from "vue";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditModalContent',
  props: {
    account: {},
    modelValue: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.tenkoAssociation.editModal.operationOffice'),
      rowContentClass: "my-auto"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(props.account?.officeable.operation_office_name), 1)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.tenkoAssociation.editModal.driverId'),
      rowContentClass: "my-auto"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(props.account?.driver_id), 1)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(FormTextField, {
      title: _unref(i18n).global.t('pages.tenkoAssociation.editModal.employeeCode'),
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      error: props.errors.employee_cd,
      required: true,
      rowContentClass: "my-auto"
    }, null, 8, ["title", "modelValue", "error"])
  ]))
}
}

})